import { createFileRoute } from '@tanstack/react-router'
import { FacilitiesPage } from '~/features/operations/FacilitiesPage'
import { facilitiesQuery } from '~/features/operations/queries'
import { Gate, RouteError } from '~/features/operations/shared'
import { mayRead } from '~/features/org/guard'

export const Route = createFileRoute('/_app/verein/betrieb/')({
  loader: async ({ context }) => {
    if (await mayRead(context.queryClient, 'ops.read')) await context.queryClient.ensureQueryData(facilitiesQuery())
  },
  component: () => (
    <Gate permission="ops.read">
      <FacilitiesPage />
    </Gate>
  ),
  errorComponent: RouteError,
})
